import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import AbEnvironment from '../auth/AbEnvironment';

const abEnvironment = new AbEnvironment();
    
const mutation = graphql`
  mutation RequestedBudgetAccountUpdateMutation($input: UpdateAccountTByAccountIdInput!) {
    updateAccountTByAccountId(input: $input) {
      accountT {
        accountId
        initialBalanceAmount
        rAutoTopupActive
        rAutoTopupAmount
        rAutoTopupThreshold
        rMaxCharge
        rMaxMonthlyBudget   
        useBudgets
        payFromBalance
      }
    }
  }
  `;

  function commit(accountId, useBudgets, payFromBalance, initialBalanceAmount, rAutoTopupActive, rAutoTopupAmount, rAutoTopupThreshold, rMaxCharge, rMaxMonthlyBudget, rMaxMonthlyBudgetSet, oneTimeFeeRequest, oneTimeFeeRequestSet) {
    var variables = {
      input: {
        accountId,
        accountTPatch: {}
      }
    };

    if (useBudgets != null)
      variables.input.accountTPatch.useBudgets = useBudgets;
    if (payFromBalance != null)
      variables.input.accountTPatch.payFromBalance = payFromBalance;
    if (initialBalanceAmount != null)
      variables.input.accountTPatch.initialBalanceAmount = initialBalanceAmount;
    if (rAutoTopupActive != null)
      variables.input.accountTPatch.rAutoTopupActive = rAutoTopupActive;
    if (rAutoTopupAmount != null)
      variables.input.accountTPatch.rAutoTopupAmount = rAutoTopupAmount;
    if (rAutoTopupThreshold != null)
      variables.input.accountTPatch.rAutoTopupThreshold = rAutoTopupThreshold;
    if (rMaxCharge != null)
      variables.input.accountTPatch.rMaxCharge = rMaxCharge;
    if (rMaxMonthlyBudgetSet === true)
      variables.input.accountTPatch.rMaxMonthlyBudget = rMaxMonthlyBudget;
    if (oneTimeFeeRequestSet === true)
      variables.input.accountTPatch.initialBalanceAmount = oneTimeFeeRequest;
  
    //if updating, always update last budget approved.
    variables.input.accountTPatch.latestBudgetApproved = 0;

    return new Promise((resolve, reject) => {
      commitMutation(
        abEnvironment.getEnvironment(), {
          mutation,
          variables,
          onCompleted: (response) => {
            resolve(response);
          },
          onError: (error) => {
            console.log("Error from mutation: " + JSON.stringify(error));
            reject(error);
          }
      }); 
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
  